import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekDialog, PeekDialogContent, PeekDialogActions, PeekButton } from "@piiqtechnologies/ui-components";
import { Formik, Form } from "formik";
import { AddOrganizationFormInitialValues, AddOrganizationFormValidationSchema, AddOrganizationFormFields, } from "./AddOrganizationForm";
import { useCreateOrganization, useError, useLoader, useNotification, useRefetch } from "@piiqtechnologies/ui-lib";
export const AddOrganizationForm = ({ onClose }) => {
    const [createOrganization, organization, createOrganizationInProgress, createOrganizationError] = useCreateOrganization();
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { setNotification } = useNotification();
    useEffect(() => {
        setLoader(createOrganizationInProgress, "createOrganizationInProgress");
        return () => setLoader(false, "createOrganizationInProgress");
    }, [createOrganizationInProgress]);
    useEffect(() => {
        if (createOrganizationError) {
            setError(createOrganizationError === null || createOrganizationError === void 0 ? void 0 : createOrganizationError.message);
        }
    }, [createOrganizationError]);
    useEffect(() => {
        if (organization) {
            setNotification(intl.formatMessage(messages.organizationSuccessCreation));
            onClose();
            setRefetch();
        }
    }, [organization]);
    const handleSubmit = (values) => {
        createOrganization({ name: values.name, domains: [values.domain] });
    };
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, fullWidth: true, title: intl.formatMessage(messages.organizationTitle), open: true, onClose: onClose },
        React.createElement(Formik, { initialValues: AddOrganizationFormInitialValues, validationSchema: AddOrganizationFormValidationSchema(), onSubmit: handleSubmit },
            React.createElement(Form, null,
                React.createElement(PeekDialogContent, null,
                    React.createElement(MultiColumnFormFields, { fullWidth: true, fields: AddOrganizationFormFields() })),
                React.createElement(PeekDialogActions, null,
                    React.createElement(PeekButton, { size: "large", type: "submit", color: "primary", variant: "contained", fullWidth: true }, intl.formatMessage(messages.organizationTitle)))))));
};
export default AddOrganizationForm;
